exports = module.exports = require("../../../../table-showoff/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ShowOffMainpage__LastTaskNavigationContainer__3V1Xg {\n  position: fixed;\n  bottom: 15px;\n  right: 10px; \n  cursor: pointer;\n  opacity: 0.4;\n\n  -webkit-transition: all 0.1s ease-in;\n\n  -o-transition: all 0.1s ease-in;\n\n  transition: all 0.1s ease-in;\n}\n\n.ShowOffMainpage__LastTaskNavigationContainer__3V1Xg:hover {\n  opacity: 1.0;\n}", ""]);

// exports
exports.locals = {
	"LastTaskNavigationContainer": "ShowOffMainpage__LastTaskNavigationContainer__3V1Xg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/ShowOffMainpage.css
// module id = 612
// module chunks = 0